module.exports = __webpack_public_path__ + "media/images/Arte_31_de_mayo-6d02ab784c669c3271987d1c73892731.png";